// src/App.js
import React, { useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import AuthContext from './context/AuthContext';
import 'bootstrap/dist/css/bootstrap.min.css';

// --- IMPORT COMPONENTI ---
import Login from './components/Login'; 
import AuthCallback from './pages/AuthCallback';
import ResetPassword from './pages/ResetPassword'; 
import Navbar from './components/Navbar'; 
import Dashboard from './components/Dashboard';

// --- MODULI DISTINTI ---
import UsersModule from './components/UsersModule';       // <--- GLOBALE (Superadmin)
import UsersLocalModule from './components/UsersLocalModule'; // <--- LOCALE (Tenant Admin)
import TenantsModule from './components/TenantsModule';
import GroupsModule from './components/GroupsModule';
import ClassesModule from './components/ClassesModule';
import ClassReport from './components/ClassReport'; // Componente per il report della classe
import UserTransferModule from './components/UserTransferModule';
import CoursesModule from './components/CoursesModule'; // 
import Profile from './components/Profile'; // Assumendo tu abbia un profilo
import TestManager from './components/TestManager'; // <--- Importa
import TestsModule from './components/TestsModule'; // <--- CREEREMO QUESTO FILE
import TestExecution from './components/TestExecution'; // Componente per l'esecuzione del test


// Layout per pagine protette
const ProtectedLayout = ({ children }) => {
    const { auth } = useContext(AuthContext);

    if (!auth.token && !localStorage.getItem('user_session')) {
        return <Navigate to="/login" replace />;
    }

    return (
        <div className="d-flex flex-column min-vh-100 bg-light">
            <Navbar />
            {/* Spazio per la Navbar Fixed */}
            <div className="container-fluid flex-grow-1 pt-5 mt-4 pb-4">
                {children}
            </div>
        </div>
    );
};

function App() {
    return (
        <AuthProvider>
            <Router>
                <Routes>
                    {/* Pubbliche */}
                    <Route path="/login" element={<Login />} />
                    <Route path="/auth/callback" element={<AuthCallback />} />
                    <Route path="/reset-password" element={<ResetPassword />} />

                    {/* Protette */}
                    <Route path="/dashboard" element={<ProtectedLayout><Dashboard /></ProtectedLayout>} />                    

                    {/* Nuova Rotta Creazione Test */}
                    <Route path="/create-test" element={
                        <ProtectedLayout>
                            <TestManager />
                        </ProtectedLayout>
                    } />

                    {/* SUPERADMIN: Utenti Globali */}
                    <Route path="/users" element={
                        <ProtectedLayout>
                            <UsersModule />  {/* <--- QUESTO DEVE ESSERE UsersModule */}
                        </ProtectedLayout>
                    } />

                    <Route path="/courses" element={
                        <ProtectedLayout>
                            <CoursesModule />  {/* <--- QUESTO DEVE ESSERE CoursesModule */}
                        </ProtectedLayout>
                    } />

                    {/* Gestione Avanzata Test */}
                    <Route path="/tests" element={
                        <ProtectedLayout>
                            <TestsModule />
                        </ProtectedLayout>
                    } />

                    {/* ADMIN & SUPERADMIN: Gestione Tenant (Container Tab) */}
                    <Route path="/tenants" element={<ProtectedLayout><TenantsModule /></ProtectedLayout>} />
                    
                    {/* Risorse Tenant */}
                    <Route path="/groups" element={<ProtectedLayout><GroupsModule /></ProtectedLayout>} />
                    <Route path="/classes" element={<ProtectedLayout><ClassesModule /></ProtectedLayout>} />
                    
                    
                    {/* MODIFICA QUI: Aggiunto ProtectedLayout per evitare redirect al login */}
                    <Route path="/class-report/:classId" element={
                        <ProtectedLayout>
                            <ClassReport />
                        </ProtectedLayout>
                    } />

                    
                    {/* Accesso diretto Utenti Tenant (usato anche dai tab) */}
                    <Route path="/users-local" element={
                        <ProtectedLayout>
                            <UsersLocalModule /> {/* <--- QUESTO DEVE ESSERE UsersLocalModule */}
                        </ProtectedLayout>
                    } />
                    
                    <Route path="/transfer-users" element={<ProtectedLayout><UserTransferModule /></ProtectedLayout>} />
                    <Route path="/profile" element={<ProtectedLayout><Profile /></ProtectedLayout>} />
                    
                    {/* MODIFICA QUI: Aggiunto ProtectedLayout per consistenza e sicurezza */}
                    <Route path="/execute-test/:testId" element={
                        <ProtectedLayout>
                            <TestExecution />
                        </ProtectedLayout>
                    } />
                    
                    <Route path="/" element={<Navigate to="/dashboard" />} />
                    <Route path="*" element={<Navigate to="/login" />} />
                </Routes>
            </Router>
        </AuthProvider>
    );
}

export default App;